import { isHttpsUrl, type BlockComponentProps } from "./shared"

export function EmbedBlock({ content, resolved }: BlockComponentProps) {
  const embUrl = (content?.url as string) ?? ""
  const embTitle = (content?.title as string) ?? "Embed"
  const embHeight = (content?.height as number) ?? 400
  if (!isHttpsUrl(embUrl)) return null
  const embSectionClass = resolved.hasOverrides
    ? `px-4 @sm:px-6 @md:px-8 ${resolved.paddingClass || "py-6"} ${resolved.cornerClass} ${resolved.alignClass} max-w-4xl mx-auto`.trim()
    : "px-4 py-6 @sm:px-6 @md:px-8 max-w-4xl mx-auto"
  return (
    <section className={embSectionClass} style={resolved.sectionStyle}>
      <iframe
        src={embUrl}
        title={embTitle}
        className="w-full rounded-lg border-0"
        style={{ height: embHeight }}
        sandbox="allow-scripts allow-same-origin"
      />
    </section>
  )
}
